import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import reportAxios from '../../../axios/report'

export const reportKpi = recordData => {
  return dispatch => {
    dispatch(reportKpiStart())

    reportAxios
      .post('/report_kpis', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report KPI',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportKpiSuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportKpiFailed())
      })
  }
}

export const reportKpiStart = () => {
  return {
    type: actionTypes.REPORT_KPI_START
  }
}

export const reportKpiSuccess = data => {
  return {
    type: actionTypes.REPORT_KPI_SUCCESS,
    data
  }
}

export const reportKpiFailed = () => {
  return {
    type: actionTypes.REPORT_KPI_FAILED
  }
}

export const clearReportKpi = () => {
  return {
    type: actionTypes.CLEAR_REPORT_KPI
  }
}
